// extracted by mini-css-extract-plugin
module.exports = {"modal":"QuickPreviewModal_modal___QDF3","mainCarousel":"QuickPreviewModal_mainCarousel__LHWXr","thumbnailSlide":"QuickPreviewModal_thumbnailSlide__rkJAL"};